import React from 'react';

var fundebug = require('fundebug-javascript');
fundebug.apikey =
  '51651e45317d4aed5fb45575a33fd6dfed065526772a755e862d2c87686134cd';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    // 将component中的报错发送到Fundebug
    fundebug.notifyError(error, {
      metaData: {
        info: info,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return '页面发生错误';
      // Note: 也可以在出错的component处展示出错信息，返回自定义的结果。
    }
    return this.props.children;
  }
}
